module.exports = __webpack_public_path__ + "img/file-type-media.5b4a6b33.svg";